/**
* 頭部菜單//用戶帳號18888888888 密碼123456 
*/ 
<template>
  <div>
   <div  :class="down? 'header this':'header'">
    <div class="headbox">
    <router-link to="/index" class="logo"><p class="p1">{{webname}}</p><p class="p2">{{webkey}}</p></router-link>
      <div :class="isopen? 'navbox this':'navbox'">
              <div class="navlist" @click="isopen=!isopen">
                 <router-link v-for="item in menudata" :to="item.path" :key="item.title" class="nav" >{{item.title}}</router-link>
              </div>

              <div class="loginbox">
                
                <div class="loginbtn" @click="loginbox=true" v-if="!userdata">
                  <div class="svgbox">
                <svg data-bbox="0 0 50 50" data-type="shape" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 50 50"><g><path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path></g></svg>
                </div>

                   <p>用戶登入</p>
                </div>
                <div class="userbtn" v-if="userdata" @click="userNav=!userNav">
                  <div class="svgbox">
                     <svg data-bbox="0 0 50 50" data-type="shape" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 50 50"><g><path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path></g></svg>
                  </div>
                  <div class="svgbox2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><g><g><polygon points="13,20.4 0,7.4 1.8,5.6 13,16.8 24.2,5.6 26,7.4   "></polygon></g></g></svg>
                   </div>
                   <div class="usernavbox" v-if="userNav">
                    <div  class="usernav" @click="gourl('/user/Bookings')">My Bookings</div>
                    <div  class="usernav"  @click="gourl('/user/Index')">My Account</div>
                    <div  class="usernav" @click="loginout()" >Sign out</div>
                   </div>
                 </div>
              </div>
      </div>
      <div :class="isopen? 'wap this':'wap'" @click="isopen=!isopen"> 
                   <div class="line"></div>
                   <div class="line"></div>
                   <div class="line"></div>
        </div>
    </div>
  

  </div>
  <div class="reg" v-if="loginbox">
          <div class="close" @click="loginbox=false;dl=1"></div>
          <div class="dlbox" v-if="dl == 1">
                 <p class="p1">你好！歡迎回來。</p>
                 <p class="p2">新用戶？<span @click="dl=2">註冊</span></p>
                 <div class="line">
                     <p class="p3">請輸入您的手機號碼<span style="color:red">*</span></p>
                     <input type="text" v-model="login.telphone" class="input1">
                 </div>
                 <div class="line">
                     <p class="p3">請輸入您的密碼<span style="color:red">*</span></p>
                     <input type="password" v-model="login.password" class="input1">
                 </div>
                 <div class="loginbtn" @click="loginIn()">登入</div>

                 <div class="wj" @click="dl=3">忘記密碼？</div>
          </div>
          <div class="dlbox" v-if="dl == 2">
            <p class="p1">註冊新帳號</p>
            <p class="p2">現有用戶？<span @click="dl=1">登錄</span></p>
            <div class="line">
                     <p class="p3">請輸入您的手機號碼<span style="color:red">*</span></p>
                     <input type="text" v-model="ureg.telphone" autocomplete="off" class="input1" >
                 </div>
                 <div class="line">
                     <p class="p3">請輸入你的名字<span style="color:red">*</span></p>
                     <input type="text" v-model="ureg.name" autocomplete="off" class="input1" >
                 </div>
                 <div class="line">
                     <p class="p3">請輸入您的密碼<span style="color:red">*</span></p>
                     <input type="password" v-model="ureg.password" autocomplete="off" class="input1">
                 </div>
                 <div class="line">
                     <p class="p3">請重複您的密碼<span style="color:red">*</span></p>
                     <input type="password" v-model="ureg.repwd" autocomplete="off" class="input1">
                 </div>
                 <div class="line2">
          
                     <input type="text" v-model="ureg.verCode" class="input2" placeholder="驗證碼" autocomplete="off">
                     <button @click="getSmsCode" :disabled="smsCountdown > 0">
                    {{ smsCountdown > 0 ? `${smsCountdown}秒後重新獲取` : '獲取短信驗證碼' }}
                  </button>
                 </div>
                 <div class="zctk">
             
                <input type="checkbox" v-model="tkqd" :class="tkqd?'tkqd this':'tkqd'"> 
                <div class="line3" @click="dialogVisible=true">
                  《只招待年齡18歲或以上女生》
                </div>
            </div>

                 <div class="loginbtn" @click="reg()">註冊</div>

          </div>
          <div class="dlbox" v-if="dl == 3">
            <p class="p1">重置密碼</p>
            <p class="p2"><span @click="dl=1">登錄/</span><span @click="dl=2">註冊</span></p>
            <div class="line">
                     <p class="p3">請輸入您的手機號碼<span style="color:red">*</span></p>
                     <input type="text" v-model="ureg.telphone" class="input1" autocomplete="off">
                 </div>
                 <div class="line">
                     <p class="p3">請輸入新的密碼<span style="color:red">*</span></p>
                     <input type="password" v-model="ureg.password" class="input1" autocomplete="off">
                 </div>
                 <div class="line">
                     <p class="p3">請重覆輸入新的密碼<span style="color:red">*</span></p>
                     <input type="password" v-model="ureg.repwd" class="input1" autocomplete="off">
                 </div>
                 <div class="line2">
          
                     <input type="text" v-model="ureg.verCode" class="input2" placeholder="驗證碼" autocomplete="off">
                     <button @click="getSmsCode2" :disabled="smsCountdown > 0">
                    {{ smsCountdown > 0 ? `${smsCountdown}秒後重新獲取` : '獲取短信驗證碼' }}
                  </button>
                 </div>
                 <div class="zctk">
             
                <input type="checkbox" v-model="tkqd" :class="tkqd?'tkqd this':'tkqd'"> 
                <div class="line3" @click="dialogVisible=true">
                  《只招待年齡18歲或以上女生》
                </div>
            </div>

                 <div class="loginbtn" @click="reg2()">確定</div>

          </div>
   </div>

   <div class="bookbtn" @click="gobook()" >Book Now</div>
   <el-dialog
  title="只招待年齡18歲或以上女生"
  :visible.sync="dialogVisible"
  width="80%"
  >
  <div v-html="zctk"></div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">不同意</el-button>
    <el-button type="primary" @click="tkqdbtn()">確 定</el-button>
  </span>
</el-dialog>
</div>
</template>
<script>
import { login,regSms,regUser,settings, fgSms,rePwd,heartbeat} from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      dialogVisible:false,
      tkqd:false,
      webname:'nomomo',
      zctk:'',
      webkey:'Professional Laser Treatment',
      loginbox:false,
      userNav:false,
      dl:1,
      isopen:false,
      login:{
        telphone:'',
        password:''
      },
      ureg:{
        telphone:'',
        password:'',
        verCode:'',
        name:'',
        email:'',
      },
      menudata:[
        {
          title:'主頁',
          path:'/index',

        },
        {
          title:'價目表',
          path:'/price',

        },
        {
          title:'品牌故事',
          path:'/story',

        },
        {
          title:'美肌教室',
          path:'/product',

        },
        {
          title:'客人評價',
          path:'/review',

        },
        {
          title:'聯絡我們',
          path:'/contact',

        }
      ],
      userdata:{},
      lastScrollPosition:0,
      down:false,
      smsCountdown: 0, // 倒計時的秒數
      smsCountdownTimer: null, // 倒計時的定時器
      headkeep: null
    }
  },
  // 創建完畢狀態(裏麵是操作)
  created() {
    this.userdata = JSON.parse(localStorage.getItem('userdata'))
    this.getst('私隱條款')
   

  },
  methods: {

    getst(parameter) {

    
    

settings(parameter)
  .then(res => {
    this.loading = false

    if (res.data.code != 1) {
      this.$message({
        type: 'info',
        message: res.message
      })
    } else {
        let dd=res.data.data.data
      if(dd.length>0){
        let path=JSON.parse(dd[0].content)['val']

        this.zctk=path
     
      }
   
       
    }
  })
  .catch(err => {
    this.loading = false
    this.$message.error('菜單加載失敗，請稍後再試！')
  })
},
validateHKPhoneNumber(phoneNumber) {
    // 正则表达式匹配香港本地手机号码格式
    const localPattern = /^(4|5|6|7|8|9)\d{7}$/;
    // 正则表达式匹配香港国际手机号码格式
    const internationalPattern = /^\+852\d{8}$/;

    // 判断是否匹配本地或国际格式
    if (localPattern.test(phoneNumber) || internationalPattern.test(phoneNumber)) {
        return true; // 是有效的香港手机号码
    } else {
        return false; // 不是有效的香港手机号码
    }
},
reg(){
      if(this.tkqd){

            if(!this.validateHKPhoneNumber(this.ureg.telphone)){
    this.$message.error('請輸入有效的手機號！')
    return false
     }
            if(this.ureg.password.length <6 || this.ureg.password.length > 20){
              this.$message.error('密碼長度必須大於6小於21位')
              return false
            }  
            if(this.ureg.password!=this.ureg.repwd){
              this.$message.error('兩次密碼不一致')
              return false
            }
            if(this.ureg.verCode==''){
              this.$message.error('請輸入驗證碼')
              return false
            }
          
            regUser(this.ureg).then(res => {
                if(res.code==1){
                  this.$message({
                      type: 'success',
                      message: '註冊成功！前往登錄！'
                    })
                   this.dl=1
                }else{
                  this.$message({
                type: 'info',
                message: res.message
              }) 
                }
   
           })
          .catch(err => {
            this.loading = false
            this.$message.error('請求失敗，請稍後再試！')
          })
      }else{
        this.$message.error('請同意條款！')
         return false
      }

    },
    reg2(){
      if(this.tkqd){

            if(!this.validateHKPhoneNumber(this.ureg.telphone)){
    this.$message.error('請輸入有效的手機號！')
    return false
     }
            if(this.ureg.password.length <6 || this.ureg.password.length > 20){
              this.$message.error('密碼長度必須大於6小於21位')
              return false
            }  
            if(this.ureg.password!=this.ureg.repwd){
              this.$message.error('兩次密碼不一致')
              return false
            }
            if(this.ureg.verCode==''){
              this.$message.error('請輸入驗證碼')
              return false
            }
          
            rePwd(this.ureg).then(res => {
                if(res.code==1){
                  this.$message({
                      type: 'success',
                      message: '修改成功！前往登錄！'
                    })
                   this.dl=1
                }else{
                  this.$message({
                type: 'info',
                message: res.message
              }) 
                }
   
           })
          .catch(err => {
            this.loading = false
            this.$message.error('請求失敗，請稍後再試！')
          })
      }else{
        this.$message.error('請同意條款！')
         return false
      }

    },
    tkqdbtn(){
        this.dialogVisible = false
        this.tkqd = true
      },
      getSmsCode(){

if(!this.validateHKPhoneNumber(this.ureg.telphone)){
this.$message.error('請輸入有效的手機號！')
return false
}
regSms(this.ureg).then(res => {

if(res.code==1){
this.$message({
                type: 'success',
                message: '驗證碼發送成功！'
              })
}else{
this.$message.error(res.message)
}
})
.catch(err => {
this.loading = false
this.$message.error('請求失敗，請稍後再試！')
})
this.smsCountdown = 60; // 假設倒計時60秒
this.smsCountdownTimer = setInterval(() => {
  if (this.smsCountdown > 0) {
    this.smsCountdown -= 1;
  } else {
    clearInterval(this.smsCountdownTimer);
  }
}, 1000);


},
getSmsCode2(){

if(!this.validateHKPhoneNumber(this.ureg.telphone)){
this.$message.error('請輸入有效的手機號！')
return false
}
fgSms(this.ureg).then(res => {

if(res.code==1){
this.$message({
                type: 'success',
                message: '驗證碼發送成功！'
              })
}else{
this.$message.error(res.message)
}
})
.catch(err => {
this.loading = false
this.$message.error('請求失敗，請稍後再試！')
})
this.smsCountdown = 60; // 假設倒計時60秒
this.smsCountdownTimer = setInterval(() => {
  if (this.smsCountdown > 0) {
    this.smsCountdown -= 1;
  } else {
    clearInterval(this.smsCountdownTimer);
  }
}, 1000);


},
    gourl(url){
      this.isopen=!this.isopen
      this.$router.push({ path: url }) 
    },
    gobook(){
       if(this.userdata!=null){
      this.$router.push({ path: '/user/Booknow' }) 
       }else{
          this.loginbox=true
       }
    },
    loginout(){
      console.log(1)
      localStorage.setItem('logintoken', null)
                // 緩存用戶個人信息
      localStorage.setItem('userdata', null)   
      this.$store.commit('login', 'false')
      location.reload()
    },
    loginIn(){

      if(this.login.telphone==''){
        this.$message.error('請輸入手機號碼！') 
        return false
       }
       if(this.login.password==''){
        this.$message.error('請輸入密碼！') 
        return false
       }
       this.loading = true
       login(this.login)
        .then(res => {
    
         if(res.code==1){
          window.scrollTo(0, 0)
          setTimeout(() => {
                this.logining = false
                // 緩存token
                localStorage.setItem('logintoken', res.data.token)
                // 緩存用戶個人信息
                localStorage.setItem('userdata', JSON.stringify(res.data))
                this.$store.commit('login', 'true')
             
            
                location.reload()
              }, 500)
         }else{
          this.$message.error(res.message)
         }
   
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜單加載失敗，請稍後再試！')
        })
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
 
      if (currentScrollPosition > 0) {
        this.down=true
      } else {
        this.down=false
      }
      // this.lastScrollPosition = currentScrollPosition;
    }
  },
  mounted() {
    // 添加滾動事件監聽
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滾動事件監聽
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.logo{color:red}
.logo .p1{
  font-size:0.23rem
}
.logo .p2{
  font-size:0.15rem
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue